import type { ReactNode } from "react";
import { Row } from "@hightouch/htui";

type Props = {
  children: ReactNode;
};

export function MediaDetailMetrics({ children }: Props) {
  return (
    <Row gap={4} flexWrap="wrap">
      {children}
    </Row>
  );
}
